<nav class='nav'>
  <div *ngFor='let page of pages' [style.width]='100/pages.length + "%"'>
    <div class="page" (mouseenter)="page.svg.htmlTrigger(true)" (mouseleave)="page.svg.htmlTrigger(false)"><a [routerLink]="'/' + page.name">{{page.name}}</a></div>
    <svg [attr.viewBox]="viewBox" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
      <path *ngFor="let path of page.svg.getPath()" [attr.class]="path.special ? 'drops' : undefined" [attr.d]="path.d" [attr.stroke-dashoffset]="path.offset"/>
    </svg>
  </div>
</nav>